import {createStore} from 'redux';

const reducer = (state , action ) =>{
	
	
	if(action.type==='STATE_EMPRESA'){
		
		return {
			
			...state,
			nodo_empresa:action.nodo_empresa,
			nombre_empresa:action.nombre_empresa			
		};
	}	

	if(action.type==='STATE_REPORT'){
				
		
		return{			
			...state,
			data_report:action.data_report,
			labels_report:action.labels_report,
			tipo_reporte:action.tipo_reporte
		};
		
	}
	if(action.type==='STATE_MOSTRAR'){		
	
		
		return{			
			...state,
			mostrar:action.mostrar		
		}
				
	}
	
	
	
	
	return state;
}



export default createStore(reducer,{nodo_empresa:'',nombre_empresa:'',data_report:[],labels_report:[],tipo_reporte:'',mostrar:'noMostrar'});


// WEBPACK FOOTER //
// ./src/store.js